module.exports = __webpack_public_path__ + "static/img/PSD16-A.91e427b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/PSD16-A.png
// module id = aFVK
// module chunks = 1